<kiene-kiene-table [tableDescriptor]="tableDescriptor"></kiene-kiene-table>
